import React from 'react';
import { motion } from 'framer-motion';
import { Home, Map, Building, Package, Briefcase, Truck } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Residential Moving',
    icon: Home,
    image: 'https://cdn.magicpatterns.com/uploads/1hB6aUphdG535ErVaKuj37/26606380-E7DE-47F2-8BB0-0DC00921B784.png',
    desc: 'Seamless transitions for your family to your new home with utmost care.'
  }, {
    title: 'Long Distance Moving',
    icon: Map,
    image: 'https://cdn.magicpatterns.com/uploads/gDiRTem8c6Gme2NxBphpQU/IMG_2952.jpg',
    desc: 'Reliable cross-country relocation services across all 50 states.'
  }, {
    title: 'Commercial Relocation',
    icon: Building,
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    desc: 'Efficient office moves designed to minimize business downtime.'
  }, {
    title: 'Packing & Unpacking',
    icon: Package,
    image: 'https://cdn.magicpatterns.com/uploads/7XaLE1ty9gbW23Z3T7y9wb/IMG_2953.jpg',
    desc: 'Professional packing services ensuring the safety of your valuables.'
  }, {
    title: 'Corporate Relocation',
    icon: Briefcase,
    image: 'https://cdn.magicpatterns.com/uploads/rB1F7fD5LAigf3h4cMs25E/IMG_2954.jpg',
    desc: 'Streamlined employee relocation programs for businesses.'
  }, {
    title: 'Loading & Unloading',
    icon: Truck,
    image: 'https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    desc: 'Expert heavy lifting and strategic truck loading services.'
  }];
  return <section id="services" className="py-24 bg-gray-light" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-204">
          <h2 className="text-gold font-sans uppercase tracking-[0.2em] font-semibold text-sm mb-4" data-id="element-205">
            Our Expertise
          </h2>
          <h3 className="text-4xl font-serif text-navy font-bold mb-6" data-id="element-206">
            Comprehensive Moving Solutions
          </h3>
          <p className="text-gray-dark/80 text-lg" data-id="element-207">
            From local Dallas residences to complex nationwide corporate
            relocations, we deliver excellence at every step of the journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-208">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group border border-gray-200 hover:border-gold" data-id="element-209">
              <div className="h-48 overflow-hidden relative" data-id="element-210">
                <div className="absolute inset-0 bg-navy/20 group-hover:bg-transparent transition-colors z-10" data-id="element-211" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-212" />
                <div className="absolute top-4 right-4 bg-white p-2 rounded-full shadow-md z-20 text-navy group-hover:text-gold transition-colors" data-id="element-213">
                  <service.icon size={20} data-id="element-214" />
                </div>
              </div>
              <div className="p-6" data-id="element-215">
                <h4 className="text-xl font-serif font-bold text-navy mb-2 group-hover:text-gold transition-colors" data-id="element-216">
                  {service.title}
                </h4>
                <p className="text-gray-dark/70 text-sm leading-relaxed" data-id="element-217">
                  {service.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}